import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// --- Layouts y Componentes de Seguridad ---
import RootLayout from "./app/layout";
import ProtectedRoute from "./components/auth/ProtectedRoute";

// --- Páginas Públicas y de Estado ---

import UnauthorizedPage from "./app/status/UnauthorizedPage";
import NotFoundPage from "./app/status/NotFoundPage";

// --- Páginas de Módulos que YA HEMOS CONSTRUIDO ---


import LoginPages from "./app/login/page";
import DashboardPages from "./app/dashboards/page";
import CasosPages from "./app/casos/page";
import ReportesPages from "./app/reportes/page";

const App: React.FC = () => {
  return (
    <Routes>
      {/* =================== ZONA PÚBLICA =================== */}
      <Route path="/login" element={<LoginPages />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />

      {/* =================== ZONA PRIVADA Y PROTEGIDA =================== */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <RootLayout />
          </ProtectedRoute>
        }
      >
        {/* --- Rutas Anidadas Dentro del Layout Principal --- */}
        
        <Route index element={<Navigate to="/dashboard" replace />} />

        <Route path="dashboard" element={<DashboardPages />} />
        
        <Route path="casos" element={<CasosPages />} />
         <Route path="reportes" element={<ReportesPages />} />
        
        {/* Las rutas para 'users' y 'config' se añadirán aquí cuando construyamos esas páginas. */}

        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
};

export default App;